module.exports = __webpack_public_path__ + "static/media/cancel.5a6e28cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/cancel.jpg
// module id = 922
// module chunks = 0